import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { JoinService } from 'apps/driver-dashboardfe/src/app/core/services/join/join.service';
import { UserDataService } from 'apps/driver-dashboardfe/src/app/core/services/user-data/user-data.service';

@Component({
    standalone: false,
    selector: 'octo-not-interested',
    templateUrl: './not-interested.component.html',
    styleUrls: ['./not-interested.component.scss'],
})
export class NotInterestedComponent implements OnInit {
    userData$ = new Subscription();
    userSummary: any;
    constructor(
        private joinService: JoinService,
        private userDataService: UserDataService
    ) {}

    ngOnInit(): void {
        this.userData$ = this.joinService
            .getUserData()
            .subscribe((data: any) => {
                this.userSummary = data;
            });
    }
    ngOnDestroy(): void {
        this.userData$.unsubscribe();
    }
}
